import type { ContactProperty } from "@shyne/shared/api";

export const CONTACT_SCOPE = "contact" as const;

export type ContactMenuItem = { title: string; url: string; icon: string };

const PROPERTY_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building2-icon lucide-building-2"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>';

const APPOINTMENTS_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-list-icon lucide-layout-list"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/><path d="M14 4h7"/><path d="M14 9h7"/><path d="M14 15h7"/><path d="M14 20h7"/></svg>';

export const contactPropertyPath = (property: Pick<ContactProperty, "id">): string => `/properties/${property.id}`;

export const CONTACT_PROPERTIES_TITLE = "Properties you're a contact for";

export const CONTACT_PROPERTIES_PATH = "/contact-properties";

export const contactPropertiesAppointmentPath = (appointment: string): string => `${CONTACT_PROPERTIES_PATH}/appointments/${appointment}`;

export const CONTACT_PROPERTIES_MENU_ITEM: ContactMenuItem = { title: CONTACT_PROPERTIES_TITLE, url: CONTACT_PROPERTIES_PATH, icon: PROPERTY_ICON };

export function contactMenu(properties: readonly ContactProperty[]): ContactMenuItem[] {
  return [
    ...properties.map((property) => ({ title: property.name, url: contactPropertyPath(property), icon: PROPERTY_ICON })),
    { title: "Appointments", url: "/appointments", icon: APPOINTMENTS_ICON },
  ];
}

export const isPropertyContact = (properties: readonly ContactProperty[]): boolean => properties.length > 0;
